import {Component, EventEmitter, Injector, Input, Output} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {StringUtil} from '../../../util/string.util';
import {DataResponse} from '../../../network/service/data.response';
import {ServiceDetailsComponent} from '../dialog/service-details/service-details.component';
import {SelectAdditivesComponent} from '../dialog/select-additives/select-additives.component';
import {isEqual} from 'lodash';
import {DeviceService} from '../../../util/service/device.service';
import {RouteUtil} from '../../../util/route.util';
import {Config} from '../../../common/config';

@Component({
  selector: 'app-service',
  standalone: false,
  templateUrl: './service.component.html',
  styleUrl: './service.component.scss'
})
export class ServiceComponent extends BaseComponent {
  @Input()
  service?: any;
  @Output()
  addToBasketClicked: EventEmitter<any> = new EventEmitter();
  @Input()
  selectedServicePriceId?: string;
  @Input()
  orders?: any = [];
  @Input()
  isLoading: boolean = false;
  heart: boolean = false;
  @Output() openDrawerRequested = new EventEmitter<void>();
  isMobile?: boolean;
  protected readonly StringUtil = StringUtil;

  constructor(injector: Injector, deviceService: DeviceService) {
    super(injector);
    this.isMobile = deviceService.isMobile();
  }

  onAddToFavoriteClicked(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.serviceApi.postEntityActionChange(this.service.ServiceId, this.service.IsFavorite ? 'UN_FAVOURITE' : 'FAVOURITE').subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.service.IsFavorite = !this.service.IsFavorite;
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onAddToBasketClicked(service: any, count?: any) {
    this.addToBasketClicked.emit({
      Service: service,
      Count: count
    });
  }

  getServiceServicePriceCount(servicePriceId: string) {
    let order = this.orders?.filter((order: any) => order.ServicePriceId === servicePriceId);
    let totalCount = 0;
    if (order) {
      for (const element of order) {
        totalCount += (element ? parseInt(element.Count) : 0);
      }
    }
    return totalCount;
  }

  onServiceCardClicked() {
    if (!this.isMobile) {
      const dialogRef = this.matDialog.open(ServiceDetailsComponent, {
        width: '100%',
        height: 'auto',
        data: {
          Service: this.service,
          onSubmit: (service: any, additives: any[]) => {
            service.ServicePriceAdditiveIds = additives;
            let order = this.orders.find((order: any) => {
              return order.ServicePriceId === this.service.ServicePrices[0].ServicePriceId &&
                isEqual(order.ServicePriceAdditiveIds, additives);
            });
            this.onAddToBasketClicked(service, ((order?.Count ?? 0) + 1));
          }
        }
      });
      dialogRef.afterClosed().subscribe(() => {
      });
    } else {
      this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.SERVICE_DETAILS_PAGE_COMPONENT, Config.branch.UniqueIdentifier, this.service.UniqueIdentifier]).then();
    }
  }

  onProductOrderClicked(value: number, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    if (this.service.ServicePrices?.length > 0 && this.service.ServicePrices[0].ServicePriceAdditives?.length > 0) {
      if (value < 0) {
        let order = this.orders.findLast((order: any) => {
          return order.ServicePriceId === this.service.ServicePrices[0].ServicePriceId;
        });
        let temp = {
          ...order.ServicePrice?.Service
        };
        temp.ServicePrices = [order.ServicePrice];
        temp.ServicePriceAdditiveIds = order.ServicePriceAdditiveIds;
        this.onAddToBasketClicked(temp, ((order?.Count ?? 0) + value));
      } else {
        const dialogRef = this.matDialog.open(SelectAdditivesComponent, {
          width: this.isMobile ? '100%' : '500px',
          height: this.isMobile ? 'auto' : 'auto',
          panelClass: this.isMobile ? 'mobile-dialog-panel' : 'desktop-dialog-panel',
          data: {
            Service: this.service,
            onSubmit: (service: any, additives: any[]) => {
              service.ServicePriceAdditiveIds = additives;
              let order = this.orders.find((order: any) => {
                return order.ServicePriceId === this.service.ServicePrices[0].ServicePriceId &&
                  isEqual(order.ServicePriceAdditiveIds, additives);
              });
              this.onAddToBasketClicked(service, ((order?.Count ?? 0) + value));
            }
          }
        });
        dialogRef.afterClosed().subscribe(() => {
        });
      }
    } else {
      let order = this.orders.find((order: any) => {
        return order.ServicePriceId === this.service.ServicePrices[0].ServicePriceId;
      });
      if (order) {
        let temp = {
          ...order.ServicePrice?.Service
        };
        temp.ServicePrices = [order.ServicePrice];
        temp.ServicePriceAdditiveIds = order.ServicePriceAdditiveIds;
        this.onAddToBasketClicked(temp, ((order?.Count ?? 0) + value));
      } else {
        this.onAddToBasketClicked(this.service, ((order?.Count ?? 0) + value));
      }
    }
    this.openDrawerRequested.emit();
  }
}
